import React, { useEffect, useState } from 'react';
import { getCurrentUser, fetchUserAttributes } from 'aws-amplify/auth';

export default function ProfilePage() {
  const [userEmail, setUserEmail] = useState('');

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const currentUser = await getCurrentUser();
        const attrs = await fetchUserAttributes();
        setUserEmail(attrs.email || currentUser.username);
      } catch (error) {
        console.error('Error fetching user:', error);
      }
    };

    fetchUser();
  }, []);

  return (
    <div style={{ textAlign: 'center', marginTop: '40px' }}>
      <div style={{
        margin: '0 auto',
        padding: '24px',
        maxWidth: '400px',
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 0 12px rgba(0,0,0,0.1)',
      }}>
        <h2 style={{ marginBottom: '20px' }}>Your Profile</h2>
        <p><strong>Name:</strong> Admin User</p>
        <p><strong>Email:</strong> {userEmail}</p>
        <p><strong>Birthdate:</strong> Not set</p>
        <p><strong>Phone:</strong> Not set</p>
        <p><strong>Address:</strong> Not set</p>
      </div>
    </div>
  );
}
